import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type DocumentIconProps = IconProps;

export const DocumentIcon: FC<DocumentIconProps> = ({
  iconColor = '#475467',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.6667 1.89111V5.33323C11.6667 5.79994 11.6667 6.0333 11.7575 6.21156C11.8374 6.36836 11.9649 6.49584 12.1217 6.57574C12.2999 6.66656 12.5333 6.66656 13 6.66656H16.4421M11.6667 14.1665H6.66667M13.3333 10.8332H6.66667M16.6667 8.32336V14.3332C16.6667 15.7333 16.6667 16.4334 16.3942 16.9681C16.1545 17.4386 15.772 17.821 15.3016 18.0607C14.7669 18.3332 14.0668 18.3332 12.6667 18.3332H7.33333C5.9332 18.3332 5.23314 18.3332 4.69836 18.0607C4.22795 17.821 3.8455 17.4386 3.60582 16.9681C3.33333 16.4334 3.33333 15.7333 3.33333 14.3332V5.6665C3.33333 4.26637 3.33333 3.56631 3.60582 3.03153C3.8455 2.56112 4.22795 2.17867 4.69836 1.93899C5.23314 1.6665 5.9332 1.6665 7.33333 1.6665H10.0098C10.6213 1.6665 10.927 1.6665 11.2147 1.73558C11.4698 1.79682 11.7137 1.89783 11.9374 2.0349C12.1897 2.18951 12.4059 2.4057 12.8382 2.83808L15.4951 5.49493C15.9275 5.92731 16.1437 6.1435 16.2983 6.39579C16.4353 6.61947 16.5363 6.86333 16.5976 7.11842C16.6667 7.40614 16.6667 7.71188 16.6667 8.32336Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
